module.exports = __webpack_public_path__ + "img/eshop.65b638b9.jpg";